import classNames from 'classnames';
import React from 'react';
import SitebarDropdown from './sitebarDropdown';
import Badge from 'src/components/badges/badge';

import { notificationToMenuItemConfig } from 'src/utils/notificationUtil';
import i18n from 'i18next';

const NotificationDropdownItem = props => {
  return (
    <li>
      <a href={props.link} className="clearfix sitebar-dropdown__item--wrap">
        <div style={{ float: 'left' }}>
          <img src={props.imageUrl} className="avatar"/>
        </div>
        <div>
          {props.name}
        </div>
      </a>
    </li>
  );
};

class NotificationsMenu extends React.Component {

  render() {
    const { open, notifications, unreadNotifications, handleClick } = this.props;
    const notifClasses = classNames({
      'notification-menu': true,
      'notification-menu--open': open,
    });
    const iconClasses = classNames({
      'icon-bell-2-solid': open,
      'icon-bell-2': !open,
    });
    const mappedNotificationItems = notificationToMenuItemConfig(notifications, unreadNotifications);
    return (
      <div className={classNames(notifClasses)}>
        <a href="#" onClick={handleClick} className="notification-menu__heading">
          <span className={iconClasses}/>
          {' '}{unreadNotifications > 0 && <Badge content={unreadNotifications} type="new" />}
        </a>
        <SitebarDropdown open={open}>
          <div className="divider">
            {i18n.t('Notifications')}
          </div>
          <ul>
            {mappedNotificationItems.map(notification => <NotificationDropdownItem {...notification} />)}
            <li>
              <a href="/notifications" className="sitebar-dropdown__link">
                {'+ ' + i18n.t('view all notifications')}
              </a>
            </li>
          </ul>
        </SitebarDropdown>
      </div>
    );
  }
}

export default NotificationsMenu;



// WEBPACK FOOTER //
// ./src/components/siteBar/notificationMenu.js